import React from "react";
import { Alert, AlertTitle, Box, Container, Typography } from "@mui/material";
import { z } from "zod";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LoaderFunction } from "react-router-dom";
import { apiClient, apiClientHooks } from "../bootstrapping/InitApiClient";
import { QueryClient } from "@tanstack/react-query";
import TestApplicationAlert from "../components/TestApplicationAlert";

/**
 * Loads the EBulkApplication by ID and ensures it's in the ReactQuery cache before loading the page
 */
export const loader = (queryClient: QueryClient): LoaderFunction => async ({ params }) => {
  const { application_id } = z.object({ application_id: z.string() }).parse(params)
  const queryKey = [...apiClientHooks.getKeyByAlias('getEBulkApplicationByID'), { params: { id: application_id } }]
  return await queryClient.ensureQueryData({ queryKey, queryFn: () => apiClient.getEBulkApplicationByID({ params: { id: application_id } }) })
}

export const Element: React.FC = () => {
  const { application_id } = useParams<{ application_id?: string }>()
  if (!application_id) throw new Error('application_id is required')

  const getEBulkApplicationByID = apiClientHooks.useGetEBulkApplicationByID({ params: { id: application_id } })

  return <>
    <Helmet>
      <title>Automated Verification</title>
    </Helmet>
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <TestApplicationAlert dbsApp={getEBulkApplicationByID.data} sx={{ marginBottom: 3 }} />
        <Typography component="h1" variant="h5" marginBottom={3}>
          Automated Verification
        </Typography>
        <Typography variant="body1" marginBottom={1}>
          Your application is eligible for automated verification. This means that we can automatically check documents you can submit digitally against various databases to verify your identity.
        </Typography>
        <Typography variant="body1" marginBottom={1}>
          If you prefer, you can follow a manual verification process instead by contacting your employer and arranging an in-person meeting.
        </Typography>
        <Typography variant="body1" marginBottom={1}>
          Please click the button below to initiate the automated verification process.
        </Typography>
        <Alert severity="info" sx={{ marginTop: 1, marginBottom: 3 }}>
          <AlertTitle>Not Ready Yet!</AlertTitle>
          This feature is not yet fully implemented.
        </Alert>

      </Box>
    </Container>
  </>
}

export default Element
